export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      items: [
        {
          type: 'text',
          label: 'Name',
          key: 'attributes.name',
          xs: 12,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      default:
        return null;
    }
  },
};
